import React, { Component } from 'react';
import { Button, Modal, Form, Message } from 'semantic-ui-react'
import TagsDropdown from '../components/tags_dropdown'
import PermissionsTable from '../components/permissions_table'
import Api from '../services/api.js'

class UserFormModal extends Component {
  constructor(props){
    super(props)
    this.state = {
      user: {
        email: '',
        role_names: ['manager'],
        profile: {
          first_name: '',
          last_name: ''
        },
        tag_list: [],
        plan_permissions: [],
      },
      emailError: false,
      passwordError: false,
      userTagOptions: [...this.props.userTagOptions],
      permissionsTableModalOpen: false,
      permissionsTableState: {
        selectAllEdit: false,
        selectAllView: false,
        planPermissions: [],
      },
      isLoading: false,
      errorMessage: ''
    }
  }

  componentDidMount = () => {
    if (this.isEditMode()) {
      this.setState({ user: {...this.props.user} }, this.getPlanPermissions)
      return
    }

    this.getPlanPermissions();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.isLoading) {
      return
    }

    if(nextProps.error) {
      let errorMessage = nextProps.error.response && nextProps.error.response.data.error
      if(errorMessage && errorMessage.includes('Email has already been taken')){
        errorMessage = `A user with the same email (${this.state.user.email}) already exists. 
                        This person may already be a user in the system. 
                        If this is not the case then use a different email address.`;
      }
      this.setState({ errorMessage });
    }
  }

  isEditMode = () => {
    return this.props.mode === 'edit'
  }

  onInputChange = (evt) => {
    var user = this.state.user
    var profile = user.profile ? user.profile : {}
    switch (evt.target.name) {
      case 'first_name':
        profile.first_name = evt.target.value
        user.profile = profile
        const firstNameError = !(profile.first_name && profile.first_name.trim());
        this.setState({
          user: user,
          firstNameError
        })
        break;
      case 'last_name':
        profile.last_name = evt.target.value
        user.profile = profile
        const lastNameError = !(profile.last_name && profile.last_name.trim());
        this.setState({
          user: user,
          lastNameError
        })
        break;
      case 'email':
        user.email = evt.target.value
        const emailError = !((/\S+@\S+/).test(String(user.email).toLowerCase()))
        this.setState({
          user: user,
          emailError: emailError
        })
        break;
      case 'password':
        user.password = evt.target.value
        const passwordError = (user.password ? (user.password.length < 6  || user.password.length > 128) : true)
        this.setState({
          user: user,
          passwordError: passwordError
        })
        break;
      case 'admin-access':
        if (evt.target.checked) {
          this.addRole('admin')
          this.setState({ planPermissionError: false })
        } else {
          this.removeRole('admin')
        }
        break;
      default:
    }

    if (!this.state.errorMessage.includes(`A user with the same email (${this.state.user.email}) already exists`)) {
      this.setState({ errorMessage: "" });
    }
  }

  invalidValues = () => {
    const user = this.state.user
    const emailError = !((/\S+@\S+/).test(String(user.email).toLowerCase()))
    let passwordError = null
    let planPermissionError = false
    const firstNameError = !(user.profile.first_name && user.profile.first_name.trim());
    const lastNameError = !(user.profile.last_name && user.profile.last_name.trim());

    if( !user.role_names.includes('admin') ){
      planPermissionError = !user.plan_permissions.some(permission => permission.can_read || permission === "update_all")
    }

    if(this.isEditMode() && !user.password){
      delete user.password
    } else {
      passwordError = (user.password ? (user.password.length < 6  || user.password.length > 128) : true)
    }

    this.setState({
      emailError: emailError,
      passwordError: passwordError,
      planPermissionError: planPermissionError,
      firstNameError,
      lastNameError
    })
    return emailError || passwordError || planPermissionError || firstNameError || lastNameError
  }

  onError = (error) => {
    let errorMessage = error.response.data.error
    let emailError = this.state.emailError
    if(errorMessage.includes('Email has already been taken')){
      emailError = true
      errorMessage = `A user with the same email (${this.state.user.email}) already exists. 
                      This person may already be a user in the system. 
                      If this is not the case then use a different email address.`;
    }
    this.setState({ errorMessage, isLoading: false, emailError })
  }

  onCreateUser = (user) => {
    const api = new Api();
    this.setState({ isLoading: true })
    api.post("/__api/v1/user", { user: user })
    .then(this.props.onSave)
    .catch(this.onError);
  }

  onUpdateUser = (user) => {
    const api = new Api();
    this.setState({ isLoading: true })
    api.put("/__api/v1/user/" + user.id, { user: user })
    .then(this.props.onSave)
    .catch(this.onError);
  }

  onSave = (evt) => {
    const user = {...this.state.user}
    user.plan_permissions = this.getSelectedPlanPermissions()
    this.setState({ user: user }, ()=>{
      if (this.invalidValues()) {
        return
      }
      
      if(this.props.mode === 'new') {
        this.onCreateUser(this.state.user)
      }else {
        this.onUpdateUser(this.state.user);
      }
    })
  }

  getSelectedPlanPermissions = () => {
    const planPermissions = []

    if( this.state.user.role_names.includes('admin') ){
      return planPermissions
    }

    if( this.state.permissionsTableState.selectAllEdit ) {
      return ['update_all']
    }

    this.state.permissionsTableState.planPermissions.forEach( permission => {
      planPermissions.push({
        can_read: permission.can_read,
        can_update: permission.can_update,
        plan_id: permission.plan_id,
        id: permission.id,
      })
    });

    return planPermissions
  }

  addRole = (role) => {
    var user = this.state.user
    if (!user.role_names.includes(role)){
      user.role_names.splice(0,0,role)
      this.setState({
        user: user
      })
    }
  }

  removeRole = (role) => {
    var user = this.state.user
    if (user.role_names.includes(role)){
      var index = user.role_names.indexOf(role);
      if (index !== -1) user.role_names.splice(index, 1);
      this.setState({
        user: user
      })
    }
  }

  onNewTag = (tag) => {
    if(!tag){ return }
    const userTagOptions = this.state.userTagOptions
    if (!userTagOptions.includes(tag)){
      userTagOptions.splice(0,0,tag)
    }
    this.setState({ userTagOptions: userTagOptions })
  }

  onApplyTags = (tagList, user) => {
    user.tag_list = tagList
    this.setState({ user: user })
  }

  removeTag = tag => {
    const user = this.state.user
    if( user.tag_list.includes(tag) ){
      var index = user.tag_list.indexOf(tag);
      if (index !== -1) user.tag_list.splice(index, 1);
      this.setState({ user: user })
    }
  }

  closePlanPermissionsTable = permissionsTableState => {
    const newState = {}
    newState.permissionsTableModalOpen = false
    if(permissionsTableState){
      newState.permissionsTableState = permissionsTableState
    }
    this.setState(newState)
  }

  getPlanPermissions = () => {
    const user = this.state.user
    const planPermissions = this.state.permissionsTableState.planPermissions
    if( user.id && planPermissions.length < 1){
      this.props.getPlanPermissions({ model: "User", model_id: user.id}).then(() => {
        const permissionsTableState = { ...this.state.permissionsTableState }
        permissionsTableState.planPermissions = this.props.planPermissions

        const can_update_all = !permissionsTableState.planPermissions.some( p => !p.can_update )
        if(can_update_all){
          permissionsTableState.selectAllEdit = true
          permissionsTableState.selectAllView = true
        } else {
          const can_read_all = !permissionsTableState.planPermissions.some( p => !p.can_read )
          if(can_read_all){
            permissionsTableState.selectAllView = true
          }
        }

        this.setState({ permissionsTableState: permissionsTableState })
      })

      return
    }

    if( planPermissions.length < 1 ){
      this.props.getPlanPermissions({model: "User"}).then(() => {
        const permissionsTableState = { ...this.state.permissionsTableState }
        permissionsTableState.planPermissions = this.props.planPermissions
        this.setState({ permissionsTableState: permissionsTableState })
      })
      return
    }
  }

  openPermissionsTable = () => {
    this.setState({ permissionsTableModalOpen: true })
  }

  render() {
    const { open, close, mode, translations, isLoading } = this.props
    const { user, emailError, passwordError, planPermissionError, firstNameError, lastNameError, errorMessage } = this.state
    var headerText = (mode === 'new' ? translations.add_user : translations.edit_user)
    const is_admin = user.role_names.includes('admin')

    return (
      <Modal className='user-form-modal' size="tiny" open={ open }>
        <Modal.Header>{ headerText }</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field error={firstNameError}>
              <label>{translations.first_name}</label>
              <input name='first_name' placeholder={translations.first_name} value={user.profile ? user.profile.first_name : ''} onChange={this.onInputChange}/>
              {
                firstNameError &&
                <p className='error-message'>Please enter a first name.</p>
              }
            </Form.Field>
            <Form.Field error={lastNameError}>
              <label>{translations.last_name}</label>
              <input name='last_name' placeholder={translations.last_name} value={user.profile ? user.profile.last_name : ''} onChange={this.onInputChange}/>
              {
                lastNameError &&
                <p className='error-message'>Please enter a last name.</p>
              }
            </Form.Field>
            <Form.Field error={emailError}>
              <label>{`${translations.email}/${translations.username}`}</label>
              <input name='email' type='email' placeholder={translations.email_placeholder} value={user.email} onChange={this.onInputChange}/>
              {
                emailError && !errorMessage &&
                <p className='error-message'>{translations.reset_email_error}</p>
              }
            </Form.Field>
            <Form.Field error={passwordError}>
              <label>{translations.password_placeholder}</label>
              <input name='password' type='password'
                     placeholder={this.isEditMode() ? "**********" : translations.password_placeholder}
                     defaultValue={user.password} onChange={this.onInputChange}/>
              {
                passwordError &&
                <p className='error-message'>{translations.password_length}</p>
              }
            </Form.Field>
            <Form.Field onClick={(evt)=>evt.stopPropagation()}>
              <div className="ui checkbox">
                <input type="checkbox" className="hidden" checked={is_admin} onChange={this.onInputChange} name='admin-access' id='admin-access'/>
                <label htmlFor='admin-access'>{translations.admin_access}</label>
              </div>
            </Form.Field>
          </Form>
          { !is_admin &&
            <React.Fragment>
              <label className="form-modal-link" onClick={this.openPermissionsTable}>
                {"Permissions"}
              </label>
              { this.state.permissionsTableModalOpen &&
                <PermissionsTable
                  user={this.state.user}
                  open={this.state.permissionsTableModalOpen}
                  translations={translations}
                  permissionsTableState={this.state.permissionsTableState}
                  close={this.closePlanPermissionsTable}
                />
              }
              { planPermissionError &&
                <p className='error-message'>{"Must have at least 1 permission"}</p>
              }
              <br/>
            </React.Fragment>
          }
          {
            <TagsDropdown
             className='tags-dropdown'
             style={{margin: 0, fontFamily: 'inherit'}}
             trigger={
               <label className="form-modal-link">
                 {translations.tags}
               </label>
             }
             header={`${translations.tag_as}:`}
             translations={translations}
             tagList={user.tag_list}
             onApply={(tagList)=>this.onApplyTags(tagList, user)}
             tagOptions={this.state.userTagOptions}
             onNewTag={this.onNewTag}
             addable={true}
             searchable={true}
            />
          }
          <br/>
          {
            user.tag_list.length > 0 &&
            <span className='tags-container'>
              {
                user.tag_list.map((tag, index)=>{
                  return(
                    <span key={index} className='tag'>{tag}
                      <i aria-hidden="true" className="delete icon"
                         onClick={e => this.removeTag(tag)}></i>
                    </span>
                  )
                })
              }
            </span>
          }
          {
            !isLoading && errorMessage &&
            <div><Message negative className='user-form-modal-error-message'>{errorMessage}</Message></div>
          }
        </Modal.Content>
        <Modal.Actions>
          <Button color='teal' fluid size='medium' className="new-plan-button" onClick={this.onSave} disabled={isLoading}>
            {translations.save} {isLoading && <span><i className="loading circle notched icon"></i></span>}
          </Button>
        </Modal.Actions>
        <i className="delete icon" onClick={ close }></i>
      </Modal>
    )
  }
}

export default UserFormModal



// WEBPACK FOOTER //
// ./src/components/user_form_modal.js